/* global translate */
import React from 'react'
import translate from '../../../../classes/lang';
import './poll_list_option.css';

const RxPollListMember = global.rootRequire('components/shares/pollComponent/pollListMember/poll_list_member').default
const {changeColorSVG, isLeaderCheck,autoConvertTime,rxaget} = global.rootRequire('classes/ulti')
const OnOffUser = global.rootRequire('components/shares/rxOnOffUser').default
export const renderComponent = (vm) =>
<div className='zpopupPool'>
  <div className='zpopupPool_bg'></div>
  <div className='zpopupPool_main'>
    <div className='zpopupPool_center'>
      {
        <div className='zpopupPool_center_bg'>
          <div className='zpopupPool-header'>
            <div className='zlistpoll-close'> 
             <img className='choose_leader_icon_close filter_img_class' alt='' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} onClick={e => vm.props.closePollPopup()} />
            </div>
            <div className='zpopupPool-title'>{translate('Poll')}</div>
            {
              <div className='zlistpoll-more' onClick={()=>{vm.chooseListMore()}}>
                <img className='zlistpoll-more-icon' alt='' src={changeColorSVG('./images/default/icons/icon-more.svg')} />
              </div>
            }

            
          </div>
          <div className='zlistpoll-header'>
            <div className='zlistpoll-header-title'>{vm.state.pollInfo.question}</div>
            <div className='zlistpoll-header-user-place'>
              <div className='zlistpoll-header-name'>{vm.state.poll_sender.group_fullname}</div>
              <div className='zlistpoll-header-time'>
              { vm.state.poll_sender.Id !== vm.props.userid ?
                <OnOffUser userId={vm.state.poll_sender.Id} className='status-online' /> :
                <div className='status-online'>Online</div>
              } 
              </div>  
            </div>
            {vm.state.pollInfo.status === 2 && <div className='zpoll-list-end-vote'> {translate('Ends at ') + autoConvertTime(rxaget(vm.state.pollInfo, 'updated_at', '')) }</div>}
          
            {
              vm.state.pollInfo.total_user_voted  > 0 &&
              <div className='zlistpoll-count-num' onClick={()=>{vm.setState({flagPollItem:true})}}>
                <span>{vm.state.pollInfo.total_user_voted} {translate(' people voted')}</span>
                <img className='zlistpoll-sort-icon' alt='' src={changeColorSVG('./images/default/icons/icon-sort.svg')}/>
                <div>
                  
                </div>
              </div>
            }
          </div>
          <div className='zlistpoll-span'>{translate('List of options')}</div>
          <div className='zlistpoll-content'>
            <div className='zpopupPool-list'>

              {
                vm.state.pollInfo &&
                vm.state.pollInfo.answers &&
                vm.state.pollInfo.answers.map((ele,index)=>
                  <div className={ele.users.length > 0 ?'zpoll-list-item-active':'zpoll-list-item'} key={ele.id}>
                    <div className='zpoll_checked'>
                      <label className='zpoll_checked_container'>
                        <input className='zpoll_checkmark1' type='checkbox'                       
                          checked={vm.state.user_answers_uin.indexOf(ele.id) !== -1}
                          onChange={e => vm.onChooseAnswer(ele)} 
                        />
                        <span className='zpoll_checkmark'></span>
                      </label>
                    </div>
                    <div className='zlistpoll_checked-title'>{ele.answer}</div>
                    <div className='zlistpoll-count '>{vm.getTotalVote(ele)}</div>
                  </div>
                )
              }

              
            </div>
            {/* <div className='zlistpoll-add' onClick={e=>vm.addPollItem()}>Thêm phương án</div> */}

          </div>
          {/* <div className='zpopupPool-validate'>{ vm.state.pollInfo.status === 2 && translate('Voting has ended')}</div> */}
          <div className='zpopupPool-footer'>
            { vm.state.pollInfo.status === 1 && (vm.state.user_answers_uin && vm.state.user_answers_uin.length >=1)  ?
              <div className='zlistpoll-btn-ok' onClick={e=>vm.createPollAnswers()}>{translate('Vote')}</div>:
              vm.state.pollInfo.status === 1 ?
                <div className='zlistpoll-btn-ok not-active'>{translate('Vote')}</div>:
                <div className='zlistpoll-btn-ok not-active'>{translate('Finished')}</div>
            }
          </div>
        </div>
      }
      {
        vm.state.flagPollItem &&
        <RxPollListMember 
          pollInfo={vm.state.pollInfo}
          closePollItemPopup={()=>vm.setState({flagPollItem:false})}
          group={vm.props.group}
        />
      }
    </div>
    {
      vm.state.flagMorePoll &&
      <div className='zpopupPool'>
        <div className='zpopupPool_bg'></div>
        <div className='zpopupPool_main'>
          <div className='zpopupPool_center'>
            <div className='zmorepool_center_bg'>
              <div className='zmorepool-option-list'>
                {
                  vm.props.group.owner_uin.toString() === vm.props.userid.toString() &&
                  vm.checkPinMess() === 1 &&
                  <div className='zmorepool-option-item-pin' onClick={()=>vm.morepollChoose('pin')}>{translate('Pin to the top of a group chat')}</div>
                }
                {
                  vm.props.group.owner_uin.toString() === vm.props.userid.toString() &&
                  vm.checkPinMess() === 2 && 
                  <div className='zmorepool-option-item-pin' onClick={()=>vm.morepollChoose('unpin')}>{translate('Unpin')}</div>
                }

                
                  <div className='zmorepool-option-item-resend' onClick={()=>vm.showPollList()}>{translate('Poll list')}</div>
                  <div className='zmorepool-option-item-resend' onClick={()=>vm.morepollChoose('send')}>{translate('Send to the chat group')}</div>
                
                {
                  vm.state.pollInfo.status === 1 &&
                  vm.props.group.owner_uin.toString() === vm.props.userid.toString() &&
                  // isLeaderCheck(vm.props.userid,vm.props.group) &&
                  <div className='zmorepool-option-item-resend' onClick={()=>vm.morepollChoose('finish-poll')}>{translate('End of voting')}</div>
                }
                {
                  vm.state.pollInfo &&
                  vm.props.group.owner_uin.toString() === vm.props.userid.toString() &&
                  <div className='zmorepool-option-item-delete' onClick={()=>vm.morepollChoose('delete')}>{translate('Delete vote')}</div>
                }
              </div>
              <div className='zmorepool-option-cancle' onClick={()=>vm.morepollChoose('cancel')}>{translate('Cancel')}</div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>